import { render, staticRenderFns } from "./NewTodoItem.vue?vue&type=template&id=68c46653"
import script from "./NewTodoItem.vue?vue&type=script&lang=js"
export * from "./NewTodoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports